import { call, put, takeLatest } from 'redux-saga/effects';
import { API } from '../api';
import { ADD_COCAPEX_LIST_ITEM, DELETE_COCAPEX_LIST_ITEM, FETCH_COCAPEX_LIST, UPDATE_COCAPEX_LIST_ITEM } from 'actions/coCapex';

function* fetchCoCapexList(action) {
    try {
        const response = yield call(API.getCoCapexData, action.payload);
        yield put({ type: FETCH_COCAPEX_LIST.SUCCESS, payload: response.data });
        action.cb && action.cb(response);
    } catch (e) {
        yield put({ type: FETCH_COCAPEX_LIST.FAIL, payload: { error: e } });
        action.cb && action.cb(e);
    }
}

function* addCoCapex(action) {
    try {
        const response = yield call(API.addCoCapexData, action.payload);
        yield put({ type: ADD_COCAPEX_LIST_ITEM.SUCCESS, payload: response.data });
        action.cb && action.cb(response);
    } catch (e) {
        yield put({ type: ADD_COCAPEX_LIST_ITEM.FAIL, payload: { error: e } });
        action.cb && action.cb(e);
    }
}

function* deleteCoCapex(action) {
    try {
        const response = yield call(API.deleteCoCapexItem, action.payload);
        yield put({ type: DELETE_COCAPEX_LIST_ITEM.SUCCESS, payload: response.data });
        action.cb && action.cb(response);
    } catch (e) {
        yield put({ type: DELETE_COCAPEX_LIST_ITEM.FAIL, payload: { error: e } });
        action.cb && action.cb(e);
    }
}

function* updateCoCapex(action) {
    try {
        const response = yield call(API.updateCoCapexItem, action.payload);
        yield put({ type: UPDATE_COCAPEX_LIST_ITEM.SUCCESS, payload: response.data });
        action.cb && action.cb(response);
    } catch (e) {
        yield put({ type: UPDATE_COCAPEX_LIST_ITEM.FAIL, payload: { error: e } });
        action.cb && action.cb(e);
    }
}

function* coCapexSaga() {
    yield takeLatest(FETCH_COCAPEX_LIST.REQUEST, fetchCoCapexList);
    yield takeLatest(ADD_COCAPEX_LIST_ITEM.REQUEST, addCoCapex);
    yield takeLatest(DELETE_COCAPEX_LIST_ITEM.REQUEST, deleteCoCapex);
    yield takeLatest(UPDATE_COCAPEX_LIST_ITEM.REQUEST, updateCoCapex);
}

export default coCapexSaga;